

import {Component, EventEmitter, Injectable, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {current} from 'codelyzer/util/syntaxKind';
@Component({
  selector: 'app-pagination-controls',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.less']

})
@Injectable()
export class PaginationControlsComponent implements OnChanges {
  @Input() currentPage: number;
  @Input() totalPages: number;
  @Output() pageChanged = new EventEmitter<number>();

  displayPages = new Array();
  leftArrowActive = false;
  rightArrowActive = false;
  paginationVisible = false;
  visible = true;
  ngOnChanges(changes: SimpleChanges ): void {
    this.initPagination();
  }
  initPagination() {
    if (this.currentPage > 0 && this.totalPages > 0) {
      this.visible = true;
      let startIndex = 1;
      this.paginationVisible = false;
      if (this.currentPage >= 4) {
        if (this.currentPage <= this.totalPages - 2) {
          startIndex = this.currentPage - 2;
        } else if (this.totalPages >= 5) {
          startIndex = this.totalPages - 4;
        }
      }
      this.displayPages = [];
      for (let i = 0; i < 5 && startIndex + i <= this.totalPages; i++) {
        this.displayPages.push(startIndex + i);
      }
      this.leftArrowActive = this.currentPage > 1;
      this.rightArrowActive = this.currentPage < this.totalPages;
      if (this.totalPages !== undefined && this.totalPages !== 1) {
        this.paginationVisible = true;
      }
    } else {
      this.visible = false;
    }
  }

  showPreviousPage() {
    this.pageChanged.emit(this.currentPage - 1);
  }
  showPage(page: number) {
    this.pageChanged.emit(page);
  }
  showNextPage() {
    this.pageChanged.emit(this.currentPage + 1);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/pagination/pagination.component.ts